module.exports = __webpack_public_path__ + "static/media/card-icon-03.6d5cef83.svg";